import styled from 'styled-components'

export const BookingCourtContainer = styled.div`
  margin-top: 25px;
`

export const BookingCourtDivider = styled.div`
  width: 100%;
  border: 1px solid #e0e0e0;
`
